/*
 * 系统各常量、设置
 *
 * */

let WEBSITE_NAME = "";

/** 顶部联系方式：为空时不展示 */
let TOP_CONTACT = {
  TEL: '',
  EMAIL: ''
};

/** 各提示处联系方式：为空时不展示 */
let TIPS_CONTACT = {
  TEL: '0755-28291983',
  EMAIL: 'service@yshinfo.com',
};

/** 预约支付时提示客服信息：为空时不展示 */
let APPOINT_CONTACT = {
  TEL: '',
  WECHAT: '',
};

/** 底部备案号 */
let RECORD_NO = '@' + new Date().getFullYear() +
    '<a  target="_blank" href="https://www.yshinfo.com/">亦笙信息</a>' +
    '<a  target="_blank" href="https://beian.miit.gov.cn/">粤ICP备18110633号</a>';

export default {
  TOP_CONTACT,
  TIPS_CONTACT,
  RECORD_NO,
  APPOINT_CONTACT,
  WEBSITE_NAME
}
